'use strict';

var browserEvent = function (target, ...args) {
  target.addEventListener(...args);
  return () => target.removeEventListener(...args);
};

var index = "<div\r\n\tid=\"{{id}}\"\r\n\tclass=\"dropdown-menu shadow bg-white rounded\"\r\n\tclass-show=\"shown\"\r\n\tstyle=\"position: absolute; left:{{positionLeft}}px; top:{{positionTop}}px;\"\r\n\ton-click=\"@this.fire('left-click-in-context-menu', {}, @event)\"\r\n>\r\n\t{{yield}}\r\n</div>";

var ractiveComponentContextMenu = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': index
});

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var require$$0 = getCjsExportFromNamespace(ractiveComponentContextMenu);

function getPosition(e) {
  let posx = 0;
  let posy = 0;

  if (e.pageX || e.pageY) {
    posx = e.pageX;
    posy = e.pageY;
  } else if (e.clientX || e.clientY) {
    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }

  return {
    x: posx,
    y: posy
  };
}

function handleMenuClick(event, ractive) {
  const id = ractive.get('id');

  if (id) {
    const element = ractive.find(`#${CSS.escape(id)}`);

    if (element && !element.contains(event.srcElement)) {
      ractive.set({
        shown: false
      });
    }
  }
}

var ractiveComponentContextMenu$1 = function createContextMenu() {
  return Ractive.extend({
    template: require$$0,

    data() {
      return {
        id: 'menu',
        shown: false,
        positionLeft: 0,
        positionTop: 0
      };
    },

    onrender() {
      const ractive = this;
      ractive.on('teardown', browserEvent(window, 'click', e => handleMenuClick(e, ractive)));
    },

    oninit() {
      const ractive = this;
      ractive.on('left-click-in-context-menu', (context, event) => {
        event.stopPropagation();
        ractive.set({
          shown: false
        });
        return false;
      });
      ractive.parent.on('contextMenu', (context, event, property) => {
        let menu;

        if (ractive && ractive.find) {
          menu = ractive.find(`#${CSS.escape(ractive.get('id'))}`);
        }

        if (property && menu && property === menu.id) {
          event.preventDefault();
          const {
            x,
            y
          } = getPosition(event.target);
          const menuWidth = menu.offsetWidth + 4;
          const menuHeight = menu.offsetHeight + 4;
          const windowWidth = window.innerWidth;
          const windowHeight = window.innerHeight;

          if (windowWidth - x < menuWidth) {
            ractive.set({
              positionLeft: windowWidth - menuWidth
            });
          } else {
            ractive.set({
              positionLeft: x
            });
          }

          if (windowHeight - y < menuHeight) {
            ractive.set({
              positionTop: menuHeight * -1
            });
          } else {
            ractive.set({
              positionTop: 40
            });
          }

          ractive.set({
            shown: true
          });
        } else {
          ractive.set({
            shown: false
          });
        }
      });
    }

  });
};

module.exports = ractiveComponentContextMenu$1;
